import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl } from "react-intl";
import { createSelector } from 'reselect';

import EnableDialogComponent from './EnableDialog';
import { selectDeselectAll, setEnableDialog } from '../../../../store/actions/associated';
import { setV2 } from '../../../../store/actions/pagesV2';

export const EnableDialog = connect(
    () => {
        const selectClaimIds = (state, props) => state.pagesV2['associated-landing'].selected;
        const selectEnableDialog = (state) => state.associated.enableDialog;

        const selectOpen = createSelector(
            selectEnableDialog,
            (enableDialog) => {
                if (enableDialog && enableDialog?.open) {
                    return true
                }
                return false
            }
        );

        const selectEnabledClick = createSelector(
            selectEnableDialog,
            (enableDialog) => {
                if (enableDialog && enableDialog?.isEnableClicked) {
                    return true
                }
                return false
            }
        )

        return (state, props) => ({
            open: selectOpen(state),
            isEnableClicked: selectEnabledClick(state),
            selectedItems: selectClaimIds(state, props),
            selectAllStatusPending: state.associated.all.pending,
        });
    },
    (dispatch) => ({
        actions: bindActionCreators({
            setSelected: (value) => setV2('associated-landing', 'selected', value),
            setEnableDialog: setEnableDialog,
            selectDeselectAll: selectDeselectAll,
        }, dispatch)
    })
)(injectIntl(EnableDialogComponent));